// Lib
import { videoViews95PercentConfig } from '@/lib/analytics/kpis/pinterest/videoViews95Percent';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerVideoViews95PercentConfig: KpiType<typeof MediaViewerKpiLoader> = {
    ...videoViews95PercentConfig,
    loader: MediaViewerKpiLoader
};
